import {Component, Input, OnInit} from '@angular/core';
import {Line } from "../../CardStruct";
import {sprintf} from "sprintf-js";
import {VariableDataBase} from "../../../variableDataBase/variable-data-base.service";
import {VariableValue} from "../../../variableDataBase/VariableValue";

@Component({
  selector: 'app-line-measurement',
  templateUrl: './line-measurement.component.html',
  styleUrls: ['./line-measurement.component.css']
})
export class LineMeasurementComponent implements OnInit {
  @Input()
  line: Line = new Line();
  itemValue: &VariableValue = new VariableValue();

  constructor(private variableDB: VariableDataBase) {
  }

  GetValue(value:VariableValue): string
  {
    return sprintf("%5.1f", value.val / 1);
  }

  ngOnInit(): void {
    this.itemValue = this.variableDB.AddValueByReference(this.line.variable.id);
  }

}
